import * as moduleActions from "../actions/module";
import {connect} from "redux-vue";
import LoadingIndicator from "./LoadingIndicator";
import classNames from "classnames";

const ModuleItem = {
  props: ["module", "setModule", "certificatePDF", "modelProp"],
  methods: {
    /**
     *
     * @param event
     */
    handleClick(event) {
      event.preventDefault();
      this.setModule(this.modelProp);
      this.$router.push("/en/courses/" + this.modelProp.id);
    },

    /**
     *
     */
    onPressDownloadCert() {
      this.certificatePDF(this.modelProp);
    }
  },
  render(h) {
    const link = (
      <a href={"/course/" + this.modelProp.id} onClick={this.handleClick}>
        {this.modelProp.name}
      </a>
    );
    const btnCertificateClass = classNames(
      "mx-1 lg:mx-0 px-2 lg:px-5 p-1 lg:p-2 rounded-full font-serif italic border border-yellow-500 focus:outline-none text-xs lg:text-base text-gray-700 whitespace-no-wrap",
      {"cursor-wait py-px": this.module.createPdf}
    );
    if (this.modelProp.completed) {
      return (
        <div class="flex flex-col lg:flex-row lg:items-center px-5 lg:px-8 lg:py-3 relative">
          <div class="lg:w-1/2">
            <div class="text-blue-800 my-3 lg:my-0 flex flex-col lg:flex-row text-center lg:text-left text-sm lg:text-base w-full lg:w-auto">
              <i class="mdi mdi-school text-yellow-500 text-4xl lg:text-base leading-none lg:leading-normal"></i>
              <span class="w-3"></span>
              {link}
            </div>
          </div>

          <div class="lg:w-1/2 pb-5 lg:pb-0">
            <div class="flex items-start lg:items-center justify-center lg:justify-between">
              <button onClick={this.onPressDownloadCert} disabled={this.module.createPdf}
                class={btnCertificateClass}
                type="button">
                {this.module.createPdf && this.module.model.id === this.modelProp.id
                  ? <LoadingIndicator/>
                  : (
                    <fragment>
                      <i class="mdi mdi-download mr-1"></i>
                      Download Certificate
                    </fragment>
                  )
                }
              </button>

              <button onClick={this.handleClick}
                class="mx-1 lg:mx-0 px-2 lg:px-5 p-1 lg:p-2 rounded-full font-serif italic bg-teal-100 border border-teal-100 focus:outline-none text-xs lg:text-base text-gray-700 whitespace-no-wrap"
                type="button">
                Review Course
                <i class="mdi mdi-arrow-right ml-1"></i>
              </button>
            </div>
          </div>
        </div>
      );
    } else {
      const moduleStarted = this.modelProp.lessons.some(each => each.activities.some(item => item.started))
        || this.modelProp.percent_complete > 0;
      const btnStart = (
        <button onClick={this.handleClick} type="button" class="mx-auto lg:mx-0 px-2 lg:px-5 p-1 lg:p-2 rounded-full font-serif italic bg-yellow-500 text-gray-800 focus:outline-none text-xs lg:text-base border border-yellow-500">
          Start Course
          <i class="mdi mdi-arrow-right ml-1"></i>
        </button>
      );
      const btnContinue = (
        <button class="mx-auto lg:mx-0 px-2 lg:px-5 p-1 lg:p-2 rounded-full font-serif italic border border-yellow-500 text-gray-800 focus:outline-none text-xs lg:text-base"
                type="button" onClick={this.handleClick}>
          Continue Course
          <i class="mdi mdi-arrow-right ml-1"></i>
        </button>
      );
      const btn = moduleStarted ? btnContinue : btnStart;
      return (
        <div class="flex flex-col lg:flex-row items-center">
          <div class="w-full lg:w-6/12 flex items-center justify-between">
            <div class="text-blue-800 lg:mr-5 my-3 lg:my-0 flex flex-col lg:flex-row text-center lg:text-left text-sm lg:text-base w-full lg:w-auto">
              <i class="mdi mdi-progress-check text-gray-800 text-4xl lg:text-base leading-none lg:leading-normal"></i>
              <span class="w-3"></span>
              {link}
            </div>

            <div class="flex lg:w-1/4 absolute bottom-0 right-0 m-6 lg:m-0 lg:relative">
              <div class="h-6 lg:h-8 w-6 lg:w-8 bg-teal-100 rounded-full">
                <div class="h-full w-full flex items-center justify-center">
                  <i class={`mdi text-teal-800 text-sm lg:text-base ${this.modelProp.mobile ? 'mdi-cellphone' : 'mdi-cellphone-off opacity-25'}`}></i>
                </div>
              </div>
              <div class="w-1"></div>
              <div class="h-6 lg:h-8 w-6 lg:w-8 bg-teal-100 rounded-full">
                <div class="h-full w-full flex items-center justify-center">
                  <i class={`mdi text-teal-800 text-sm lg:text-base ${this.modelProp.desktop ? 'mdi-laptop' : 'mdi-laptop-off opacity-25'}`}></i>
                </div>
              </div>
            </div>
          </div>

          <div class="w-full lg:w-6/12 pb-5 lg:pb-0">
            <div class="flex flex-col lg:flex-row items-start lg:items-center lg:justify-between">
              <p class="text-center text-xs font-bold lg:hidden w-full">
                Progress
              </p>

              <div class="flex w-full lg:w-2/3 mt-1 mb-5 lg:my-5">
                <div class="inline-block text-sm lg:text-base w-12">{this.modelProp.percent_complete}%</div>
                <div class="inline-block w-full lg:w-3/5 bg-gray-300 rounded-full overflow-hidden">
                  <div class="h-full bg-yellow-500 rounded-full w-full duration-300 ease-in-out" style={`transform: translateX(${this.modelProp.percent_complete - 100}%)`}></div>
                </div>
              </div>
              {btn}
            </div>
          </div>
        </div>
      );
    }
  }
};

function mapStateToProps(state) {
  return {
    module: state.module
  };
}

function mapActionToProps(dispatch) {
  return {
    setModule: module => dispatch(moduleActions.setModule(module)),
    certificatePDF: module => dispatch(moduleActions.certificatePDF(module))
  };
}

export default connect(mapStateToProps, mapActionToProps)(ModuleItem);
